// extracted by mini-css-extract-plugin
export default {"PartOne":"Part1_PartOne__e7+ot","CTA":"Part1_CTA__32-9N","cfa":"Part1_cfa__6UI+X"};